<template>
  <div id="app" :class="cookieTheme">
    <HeaderPPR></HeaderPPR>
    <div class="main-container">
      <div class="slider f_left">
        <Slider></Slider>
        <Waffle></Waffle>
      </div>
      <div class="main f_left">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderPPR from "@/components/HeaderPPR";
import Waffle from "@/components/Waffle";
import Slider from "@/components/Slider";
import Tool from "@/assets/js/common/utils.js";
import Cookies from "js-cookie";
import { mapState } from 'vuex';
export default {
  name: "App",
  components: {
    HeaderPPR,
    Slider,
    Waffle
  },
  data() {
    return {
      cookieTheme: ''
    };
  },
  computed: {
    ...mapState({
      theme: (state) => state.theme,
    }),
  },
  watch: {
    theme() {
      // this.cookieTheme = Cookies.get("userTheme")
      
    }
  },
  created() {
    // this.cookieTheme = Cookies.get("userTheme")
    const cookie = Tool.getCookie();
    if (cookie) {
      Tool.setCookie(cookie);
    }
    // document.title = 'TVU ' + this.$t('lang.TVURecordingService')
  },
};
</script>

<style lang="less" scoped>
#app {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}

.main-container {
  width: 100%;
  height: calc(100% - 64px);
  max-height: calc(100% - 64px);
  /*margin: 0 32px;*/
  margin-top: 64px;
  overflow-y: hidden;
  z-index: 1;

  .slider {
    width: 256px;
    height: 100%;
    background: rgba(246, 247, 250, 1);
  }

  .main {
    width: calc(100% - 320px);
    height: 100%;
    margin-left: 32px;
  }
}
// / ####### Dark Theme ####### /
.dark {
    .main-container{
        .slider{
        background: #242628;
        }
  }
}
</style>
